import {
  Component,
  h,
  Prop,
  ComponentInterface,
  Element,
  Method,
  Host,
} from '@stencil/core';

@Component({
  tag: 'signet-dialog',
  styleUrl: 'signet-dialog.scss',
})
export class SignetDialog implements ComponentInterface {
  $overlay: HTMLSignetOverlayElement;
  titleId = `dialog_title_${dialogIds++}`;

  @Element() $el: HTMLElement;

  @Prop() dialogTitle: string;
  @Prop() size: 'sm' | 'md' | 'lg' = 'md';

  @Method()
  async show() {
    await this.$overlay.show();
  }

  @Method()
  async hide() {
    await this.$overlay.hide();
  }

  render() {
    return (
      <Host class="signet-dialog">
        <signet-overlay
          title-id={this.titleId}
          ref={(el) => (this.$overlay = el)}
        >
          <div class={`dialog-wrapper size-${this.size}`}>
            <header class="dialog-header">
              <h3 class="dialog-title" id={this.titleId}>
                {this.dialogTitle}
              </h3>
            </header>
            <div class="dialog-content">
              <slot />
            </div>
          </div>
        </signet-overlay>
      </Host>
    );
  }
}

let dialogIds = 0;
